import API from "./API";

const login = async (username, password) => {
  return await API.post(
    "/user/login",
    {
      user_id: username,
      password: password,
    }
  )
    .then((res) => {
      sessionStorage.setItem("session_key", res.data.session_key);
      sessionStorage.setItem("username", username);
   
    })
    .catch((e) => null);
};

export { login };

